import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    rootPage: '',
    theArticle: {}
  },
  getters: {
    getRoot: state => {
      return state.rootPage;
    },
    getArticle: state => {
      return state.theArticle;
    }
  },
  mutations: {
    setRoot: (state, root) => {
      state.rootPage = root;
    },
    setArticle: (state, article) => {
      state.theArticle = article;
    }
  },
  actions: {},
  modules: {}
});
